_ = require 'lodash'
classnames = require 'classnames'
FeedbackButton = require './FeedbackButton'
immutable = require 'seamless-immutable'
moment = require 'moment'
React = require 'react'
ReactTooltip = require 'react-tooltip'
require '../../styles/ObserveStudent'
{ Button, ButtonGroup, DropdownButton, MenuItem } = require 'react-bootstrap'
{ Component, PropTypes } = require 'react'

{
	BEHAVIOR_TYPE_IDS: {
		ON_TASK
		OFF_TASK
	}
	CONTEXT_IDS: {
		WHOLE_CLASS
		SMALL_GROUP
		INDIV
	}
	GRADE_LEVEL_IDS: {
		KINDERGARTEN
		PRE_K
	}
	MANAGEMENT_IDS: {
		TEACHER
		PEERS
		ALONE
	}
	INSTRUCTION_TYPE_IDS: {
		MEANING_FOCUSED
		CODE_FOCUSED
		PLAY
		NUMBER_OPERATIONS
		ALGEBRA
		GEOMETRY
		APPLIED
		OPERATIONS
	}
	OBSERVATION_SUBJECT_IDS: {
		NON_INSTRUCTION
		ART
		LITERACY
		MATH
		MUSIC
		OTHER
		SCIENCE
		SOCIAL_STUDIES
		MEAL_TIME
		SOCIOEMOTIONAL_LEARNING
		OFF_CAMERA
	}
} = require '../lib/commonIds'

ObserveStudent = React.createClass
	propTypes: {
		cycleNumber: PropTypes.number.isRequired
		endStudentObservation: PropTypes.func.isRequired
		gradeLevelId: PropTypes.number.isRequired
		recordStudentEvent: PropTypes.func.isRequired
		recordStudentObservation: PropTypes.func.isRequired
		setContextToWholeClass: PropTypes.func.isRequired
		student: PropTypes.object.isRequired
		timer: PropTypes.string.isRequired
	}

	getInitialState: () ->
		return {
			eventIdsBeingAnimated: {
				# These are the student_event_type IDs from the database.
				1: false
				2: false
				3: false
				4: false
				5: false
				6: false
				7: false
				8: false
				9: false
				10: false
				11: false
				12: false
			}
		}

	componentWillMount: ->
		mostRecentStudentObservation = @props.getMostRecentStudentObservation(@props.student.id)

		if mostRecentStudentObservation == null || !!mostRecentStudentObservation.ended_at
			@props.recordStudentObservation(@props.student.id, )

	componentWillUnmount: ->
		@props.endStudentObservation(@props.student.id)

	componentDidUpdate: ->
		ReactTooltip.rebuild()

	recordStudentEvent: (eventId) ->
		# Record the event
		@props.recordStudentEvent(@props.student.id, eventId)

		# Give the user some animated feedback to indicate that the click ws received
		{ eventIdsBeingAnimated } = @state
		eventIdsBeingAnimated[eventId] = true;
		@setState({ eventIdsBeingAnimated })

		setTimeout =>
			{ eventIdsBeingAnimated } = @state
			eventIdsBeingAnimated[eventId] = true;
			@setState({ eventIdsBeingAnimated })
		, 750

	isDisabledContext: (contextId) ->
		studentObservation = @props.getMostRecentStudentObservation(@props.student.id)
		if studentObservation?.observation_management_id == PEERS && contextId != SMALL_GROUP
			return true
		else if studentObservation?.observation_management_id == ALONE && contextId != INDIV
			return true
		else
			return false

	isDisabledManagement: (managementId) ->
		studentObservation = @props.getMostRecentStudentObservation(@props.student.id)
		studentObservation?.observation_subject_id == NON_INSTRUCTION

	getEventTypeButtons: ->
		buttonGroups = {
			warning: [
				{ id: 1, description: 'Non-verbal responding' },
				{ id: 2, description: 'Verbal response to question' },
				{ id: 3, description: 'Reading text/problems aloud' },
			],
			success: [
				{ id: 4, description: 'Answering questions that require reasoning' },
				{ id: 12, description: 'Asking on-topic questions' },
				{ id: 5, description: 'Using text to justify a response' },
				{ id: 6, description: 'Participating in a discussion' },
				{ id: 7, description: 'Voicing a disagreement' },
			],
			primary: [
				{ id: 10, description: 'In a challenging social situation, uses words to resolve issue' },
				{ id: 11, description: 'Moves away from difficult social situations' }
			]
		}

		buttons = []

		Object.keys(buttonGroups).map (buttonType) =>
			buttonGroup = buttonGroups[buttonType]

			buttons.push (
				React.createElement("div", {"className": "moves-buttons", "key": ( "btn-group-" + buttonType )},
					(
						buttonGroup.map (eventType) =>
							React.createElement(FeedbackButton, { \
								"key": ( eventType.id ),  \
								"className": (  "btn btn-" + buttonType  ),  \
								"onClick": ( => @props.recordStudentEvent(@props.student.id, eventType.id) ),  \
								"innerHTML": ( eventType.description )
							})
					)
				)
			)

		return buttons

	render: ->
		{ eventIdsBeingAnimated } = @state
		studentObservation = @props.getMostRecentStudentObservation(@props.student.id)

		subjectTitle = switch studentObservation?.observation_subject_id
			when ART then 'Art'
			when SCIENCE then 'Science'
			when SOCIAL_STUDIES then 'Soc. St.'
			when MUSIC then 'Music'
			when MEAL_TIME then 'Meal'
			when SOCIOEMOTIONAL_LEARNING then 'SEL'
			when OFF_CAMERA then 'Off Cam'
			else 'Other'

		React.createElement("div", {"className": "observe-card observe-student"},
			React.createElement(ReactTooltip, {"delayShow": ( 700 )}),
			React.createElement("div", {"className": "toggle-list"},
				React.createElement("div", {"className": "name"}, (@props.student.first_name), " ", (@props.student.last_name)),
				React.createElement("div", {"className": "behaviors"},
					React.createElement(ButtonGroup, {"className": "center-btns btn-grouping"},
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"className": ( classnames { 'on-task-button': true, selected: studentObservation?.student_behavior_type_id == ON_TASK } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'student_behavior_type_id', ON_TASK) )
							}, """
\t\t\t\t\t\t\t\tIs on task
""")
						),
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"className": ( classnames { 'off-task-button': true, selected: studentObservation?.student_behavior_type_id == OFF_TASK } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'student_behavior_type_id', OFF_TASK) )
							}, """
\t\t\t\t\t\t\t\tIs off task
""")
						)
					)
				),
				React.createElement("div", {"className": "subjects"},
					React.createElement("h4", {"className": "observation-heading"}, "Content Area"),
					React.createElement(ButtonGroup, {"className": "btn-grouping"},
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"className": ( classnames { selected: studentObservation?.observation_subject_id == LITERACY } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', LITERACY) )
							}, """
\t\t\t\t\t\t\t\tLiteracy
""")
						),
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"className": ( classnames { selected: studentObservation?.observation_subject_id == MATH } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', MATH) )
							}, """
\t\t\t\t\t\t\t\tMath
""")
						),
						React.createElement(DropdownButton, { \
							"title": ( subjectTitle ),  \
							"className": (
								classnames({
									selected: [
										ART,
										SCIENCE,
										SOCIAL_STUDIES,
										MUSIC,
										OTHER,
										MEAL_TIME,
										SOCIOEMOTIONAL_LEARNING,
										OFF_CAMERA
									].includes(studentObservation?.observation_subject_id)
								})
							),  \
							"id": ( @props.student.first_name + '-' + @props.student.last_name + '-subject-dropdown' )
						},
							React.createElement(MenuItem, { \
								"eventKey": ( String(ART) ),  \
								"active": ( studentObservation?.observation_subject_id == ART ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', ART) )
							}, """
\t\t\t\t\t\t\t\tArt
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(SCIENCE) ),  \
								"active": ( studentObservation?.observation_subject_id == SCIENCE ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', SCIENCE) )
							}, """
\t\t\t\t\t\t\t\tScience
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(SOCIAL_STUDIES) ),  \
								"active": ( studentObservation?.observation_subject_id == SOCIAL_STUDIES ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', SOCIAL_STUDIES) )
							}, """
\t\t\t\t\t\t\t\tSocial Studies
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(MUSIC) ),  \
								"active": ( studentObservation?.observation_subject_id == MUSIC ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', MUSIC) )
							}, """
\t\t\t\t\t\t\t\tMusic
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(MEAL_TIME) ),  \
								"active": ( studentObservation?.observation_subject_id == MEAL_TIME ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', MEAL_TIME) )
							}, """
\t\t\t\t\t\t\t\tMeal Time
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(SOCIOEMOTIONAL_LEARNING) ),  \
								"active": ( studentObservation?.observation_subject_id == SOCIOEMOTIONAL_LEARNING ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', SOCIOEMOTIONAL_LEARNING) )
							}, """
\t\t\t\t\t\t\t\tSocioemotional Learning
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(OFF_CAMERA) ),  \
								"active": ( studentObservation?.observation_subject_id == OFF_CAMERA ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', OFF_CAMERA) )
							}, """
\t\t\t\t\t\t\t\tOff Camera
"""),
							React.createElement(MenuItem, { \
								"eventKey": ( String(OTHER) ),  \
								"active": ( studentObservation?.observation_subject_id == OTHER ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', OTHER) )
							}, """
\t\t\t\t\t\t\t\tOther
""")
						),
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"className": ( classnames { selected: studentObservation?.observation_subject_id == NON_INSTRUCTION } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_subject_id', NON_INSTRUCTION) ),  \
								"data-tip": "Non-instruction"
							}, """
\t\t\t\t\t\t\t\tNon-Inst
""")
						)
					)
				),
				React.createElement("div", {"className": "grouping"},
					React.createElement("h4", {"className": "observation-heading"}, "Context"),
					React.createElement(ButtonGroup, {"className": "btn-grouping"},
					 React.createElement(ButtonGroup, null,
					 	React.createElement(Button, { \
					 		"disabled": ( @isDisabledContext(WHOLE_CLASS) ),  \
					 		"className": ( classnames { selected: studentObservation?.observation_context_id == WHOLE_CLASS } ),  \
					 		"onClick": ( @props.setContextToWholeClass ),  \
					 		"data-tip": "Whole class"
					 	}, """
\t\t\t\t\t \t\tWC
""")
					 ),
					 React.createElement(ButtonGroup, null,
					 	React.createElement(Button, { \
					 		"disabled": ( @isDisabledContext(SMALL_GROUP) ),  \
					 		"className": ( classnames { selected: studentObservation?.observation_context_id == SMALL_GROUP } ),  \
					 		"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_context_id', SMALL_GROUP) ),  \
					 		"data-tip": "Small group"
					 	}, """
\t\t\t\t\t \t\tSmG
""")
					 ),
					 React.createElement(ButtonGroup, null,
					 	React.createElement(Button, { \
					 		"disabled": ( @isDisabledContext(INDIV) ),  \
					 		"className": ( classnames { selected: studentObservation?.observation_context_id == INDIV } ),  \
					 		"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_context_id', INDIV) ),  \
					 		"data-tip": "Individual"
					 	}, """
\t\t\t\t\t \t\tIndiv
""")
					 )
					),
					React.createElement(ButtonGroup, {"className": "btn-grouping"},
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"className": ( classnames { selected: studentObservation?.observation_management_id == TEACHER } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_management_id', TEACHER) )
							}, """
\t\t\t\t\t\t\t\tTeacher
""")
						),
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"disabled": ( @isDisabledManagement(PEERS) ),  \
								"className": ( classnames { selected: studentObservation?.observation_management_id == PEERS } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_management_id', PEERS) )
							}, """
\t\t\t\t\t\t\t\tPeers
""")
						),
						React.createElement(ButtonGroup, null,
							React.createElement(Button, { \
								"disabled": ( @isDisabledManagement(ALONE) ),  \
								"className": ( classnames { selected: studentObservation?.observation_management_id == ALONE } ),  \
								"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_management_id', ALONE) )
							}, """
\t\t\t\t\t\t\t\tAlone
""")
						)
					)
				),
				React.createElement("div", {"className": ( classnames 'instruction-types': true, 'visibility-hidden': ![LITERACY, MATH].includes(studentObservation?.observation_subject_id) )},
					React.createElement("h4", {"className": "observation-heading"}, "Instruction Type"),
					(
						if studentObservation?.observation_subject_id == MATH
							React.createElement(ButtonGroup, {"className": "btn-grouping"},
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == NUMBER_OPERATIONS } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', NUMBER_OPERATIONS) ),  \
										"data-tip": "Numbers"
									}, """
\t\t\t\t\t\t\t\t\t\tNu
""")
								),
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == OPERATIONS } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', OPERATIONS) ),  \
										"data-tip": "Operations"
									}, """
\t\t\t\t\t\t\t\t\t\tOp
""")
								),
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == ALGEBRA } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', ALGEBRA) ),  \
										"data-tip": "Algebra"
									}, """
\t\t\t\t\t\t\t\t\t\tAl
""")
								),
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == GEOMETRY } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', GEOMETRY) ),  \
										"data-tip": "Geometry"
									}, """
\t\t\t\t\t\t\t\t\t\tGo
""")
								),
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == APPLIED } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', APPLIED) ),  \
										"data-tip": "Applied"
									}, """
\t\t\t\t\t\t\t\t\t\tAp
""")
								)
							)
						else
							React.createElement(ButtonGroup, {"className": "btn-grouping"},
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == CODE_FOCUSED } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', CODE_FOCUSED) ),  \
										"data-tip": "Code-focused"
									}, """
\t\t\t\t\t\t\t\t\t\tCF
""")
								),
								React.createElement(ButtonGroup, null,
									React.createElement(Button, { \
										"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == MEANING_FOCUSED } ),  \
										"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', MEANING_FOCUSED) ),  \
										"data-tip": "Meaning-focused"
									}, """
\t\t\t\t\t\t\t\t\t\tMF
""")
								),
								(
									if (@props.gradeLevelId == KINDERGARTEN || @props.gradeLevelId == PRE_K) && studentObservation?.observation_subject_id == LITERACY
										React.createElement(ButtonGroup, null,
											React.createElement(Button, { \
												"className": ( classnames { selected: studentObservation?.observation_instruction_type_id == PLAY } ),  \
												"onClick": ( => @props.recordStudentObservation(@props.student.id, 'observation_instruction_type_id', PLAY) )
											}, """
\t\t\t\t\t\t\t\t\t\t\t\tPlay
""")
										)
								)
							)
					)
				)
			),
			React.createElement("div", {"className": "events"},
				React.createElement("h4", {"className": "observation-heading"}, "Moves"),
				( @getEventTypeButtons() )
			)
		)

module.exports = ObserveStudent



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/ObserveStudent.cjsx